/* eslint-disable no-underscore-dangle */
export const __prod__ = process.env.NODE_ENV === 'production';

export const CONTRACT_ADDRESS = process.env.REACT_APP_SC_ADDRESS || '0xf7933fb707e79256aB449D53F8bF86561cCc4dFD';

export const NETWORK_CHAIN_IDS = {
  mainnet: 1,
  ropsten: 3,
  rinkeby: 4,
  goerli: 5,
  kovan: 42,
  localhost: 1337,
};

export const INFURA_ID = '0dfacdfb826644cda2ee5d402d8cfef8';

// TEST NET
// export const INFURA_ENDPOINT = 'https://rinkeby.infura.io/v3/0dfacdfb826644cda2ee5d402d8cfef8';
// export const WND_CONTRACT = '0xa6c5ca5aafc65cceb22be08a8b1e1eff16d7292c';
// export const WND_GAME_CONTRACT = '0x1d261f229f4610A6594131CB0e72B0A7011159CF';
// export const TOWER_CONTRACT = '0xf5e63b49a9049ffe741ea39d2bc5f2923fc71e43';
// export const GP_TOKEN_CONTRACt = '0xc0134746c1d274479f9962238abcd4569ae7c877';
// MAIN NET

export const INFURA_ENDPOINT = 'https://mainnet.infura.io/v3/0dfacdfb826644cda2ee5d402d8cfef8';
export const WND_CONTRACT = '0x999e88075692bCeE3dBC07e7E64cD32f39A1D3ab';
export const WND_GAME_CONTRACT = '0xa084811e350B0E0A07cD4BD8d762ed7ed070b73B';
export const TOWER_CONTRACT = '0xF042A49FB03cb9D98CbA9DEf8711CEE85dC72281';
export const GP_TOKEN_CONTRACt = '0x38Ec27c6F05a169e7eD03132bcA7d0cfeE93C2C5';

export const APPROVE_AMOUNT = '115792089237316195423570985008687907853269984665640564039457584007913129639935'; //(2^256 - 1 )
export const MIN_PRICE = 0.088;
export const MAX_PRICE = 0.42069;
export const PRICE_DECEREMENT_AMOUNT = 0.01;
